import { createSelector } from 'reselect'
import configurationDataSelector from './configurationDataSelector'

const foresightedBuildabilityIsStepBackSelector = createSelector(
    configurationDataSelector,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (configurationData): boolean => {
        return false
    },
)

export default foresightedBuildabilityIsStepBackSelector
